import { render, staticRenderFns } from "./ChapterTable.vue?vue&type=template&id=74bbcbdb&scoped=true"
import script from "./ChapterTable.vue?vue&type=script&lang=js"
export * from "./ChapterTable.vue?vue&type=script&lang=js"
import style0 from "./ChapterTable.vue?vue&type=style&index=0&id=74bbcbdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bbcbdb",
  null
  
)

export default component.exports